/**
 * Order of the sidebar groups (`sidebar_group` in `_category.mdx`).
 *
 * Shared by the site's own sidebar (`main.tsx`) and the categories manifest,
 * so the admin console lists categories in the same order the docs show them.
 */
export const SIDEBAR_GROUP_ORDER = ["quickstart", "conceptos", "guías", "referencia"] as const
